import { Component, OnInit } from '@angular/core';
import * as AOS from 'aos';

@Component({
  selector: 'mm-part9',
  templateUrl: './part9.component.html',
  styleUrls: ['./part9.component.scss']
})
export class part9Component implements OnInit {
  readonly baseElementURL = './assets/images/element/';

  readonly lstText: string[] = [`<strong>מאוד נהננו. היה ממש חוויה.</strong> <br/>
  חבל שלא צילמו את הצעקות כל פעם שאמרת שהייאט ידעו את התשובה. <br/> 
  מקווה שאתה מוכר את כל הסקרים...  <br/>
  זה מחקר טוב!  <br/>
  <br/>
  תודה רבה!  <br/>
  ש. אייכלר  `
    ,
    `אני אחת המורות שהיו שותפוות עכשיו בבנות אלישיב,<br/>
    ורציתי לומר שהיה פשוט מ-ד-ה-י-ם!!!  <br/>  
    <br/>
    <strong>הבנות נהנו בצורה לא רגילה!!! ואפילו המשפחות היו שותפות. </strong>  <br/>
    והם שאלו שוב ושוב מי הייתה המנחה ואיזה יפה היא הנחתה וכו’ וכו’  <br/> 
    <br/>
    תודה רבה רבה תמשיכו לשמח אנשים :)   <br/>
    תמר י.    `
    ,
    `<strong>מאוד נהננו. היה ממש חוויה.</strong> <br/>
    חבל שלא צילמו את הצעקות כל פעם שאמרת שהייאט ידעו את התשובה.   <br/>  
    מקווה שאתה מוכר את כל הסקרים...    <br/> 
    זה מחקר טוב!    
    <br/>
    תודה רבה!   <br/>  
    ש. אייכלר    `
  ]

  readonly baseURL = './assets/images/part9/';

  readonly frameContents = [{
    imgUrl: 'video-white.png',
    imgColorUrl: 'video-color.png'
  }, {
    imgUrl: 'phone-white.png',
    imgColorUrl: 'phone-color.png'
  }, {
    imgUrl: 'leptop-white.png',
    imgColorUrl: 'leptop-color.png'
  }
  ];

  currentFrameContents = 0;
  constructor() { }

  ngOnInit(): void {
  }
  scrollToById(index) {
    this.currentFrameContents=index;
  }
}
